import { IPlugin } from '@/types';
import Image from 'next/image';
import Link from 'next/link';
import { Section } from '../section/section.comp';
import { StyledDiv } from './widgetCatalog.styles';

export const WidgetCatalog = ({
	apps = [],
	platform,
}: {
	apps: IPlugin[];
	appSynonym?: string;
	platform?: { name: string; displayName: string; appSynonym: string };
}) => {
	const appSynonym = platform?.appSynonym || 'app';

	return (
		<Section>
			<StyledDiv>
				<p>Common Ninja Apps</p>
				<h2>
					Some of the best Common Ninja {appSynonym}s for{' '}
					{platform?.displayName || 'your website'}
				</h2>
				<p className="desc">
					Browse our extensive collection of compatible {appSynonym}s, and
					easily embed them on any website, blog, online store, e-commerce
					platform, or site builder.
				</p>
				<div className="apps-container">
					{apps.length > 0 &&
						apps.map((plugin: IPlugin) => {
							let path = `https://www.commoninja.com/widgets/${plugin.slug}?via=discover&ref=searchengine&utm_source=discover&utm_medium=referral&utm_campaign=${plugin.name}`;

							if (platform?.name) {
								path = `https://www.commoninja.com/widgets/${plugin.slug}/${platform?.name}?via=discover&ref=searchengine&utm_source=discover&utm_medium=referral&utm_campaign=${plugin.name}`;
							}

							return (
								<Link
									title={`${plugin.name || ''} ${
										platform?.displayName ? `for ${platform.displayName}` : ''
									}`}
									key={plugin.name || ''}
									className="app"
									href={path}
								>
									<Image
										src={plugin.logo}
										alt={`${plugin.name || ''} ${
											platform?.displayName ? `for ${platform.displayName}` : ''
										} logo`}
										width={50}
										height={50}
									/>
									<div className="details">
										<h3>{plugin.name || ''}</h3>
										<p>{plugin.teaser}</p>
									</div>
								</Link>
							);
						})}
				</div>
			</StyledDiv>
		</Section>
	);
};
